<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      new_asin: {
        asin: null,
      },
      isNewAsinValid: null,
      isAsinChecking: false,
      qty: 1,
      new_qty: null,
      comment: null,
      dimensions: null,
      dimensions_error: null,
    };
  },
  computed: {
    ...mapGetters({ product: 'modal_edit_products' }),
    isSaveAllow() {
      // todo создать массив ошибок и на основании массива делать активной или нет кнопку
      if (this.qty > this.product.ids.length) return false;
      if (this.new_qty < 0) return false;
      if (
        (this.new_asin.asin !== null && this.isNewAsinValid === false) || this.isAsinChecking
      ) return false;

      return true;
    },
    is_storage() {
      return this.$store.getters.is_storage;
    },
    getDemensions() {
      const { width, height, length } = this.dimensions;

      return ((((width * height * length) / 1728) * 1000) / 1000) || 0;
    },
  },
  methods: {
    save() {
      if (!this.isSaveAllow) return;

      const data = {
        ids: this.product.ids.slice(0, this.qty),
        new_asin: this.new_asin.asin,
        new_qty: this.new_qty,
        worker_comment: this.comment,
        dimensions: this.dimensions,
      };

      this.$store.dispatch('update_product', data)
        .then(() => this.$store.commit('set_modal_edit_products', null));
    },
    close(event) {
      if (!event.target.closest('.modal-container') || event.target.classList.contains('close')) {
        this.$store.commit('set_modal_edit_products', null);
      }
    },
    checkNewAsin(value) {
      this.isAsinChecking = true;
      this.$store.dispatch('getASINInfo', value)
        .then((data) => {
          this.new_asin = {
            image: data.image,
            title: data.title,
            asin: data.asin,
          };
          this.isNewAsinValid = data.asin === this.new_asin.asin;
        })
        .catch((error) => {
          this.isNewAsinValid = false;
          console.error('Error:', error);
        })
        .finally(() => { this.isAsinChecking = false; });
    },
    changeAsin(value) {
      if (!value || !/^[A-Z0-9]{10}$/.test(this.new_asin.asin)) {
        this.isNewAsinValid = null;
        return;
      }
      _.debounce(() => this.checkNewAsin(value), 30, false)();
    },
    maxLength(property, value) {
      this.dimensions[property] = value.slice(0, 4);
    },
    fromAmazon() {
      this.$store.dispatch('get_dimensions_from_amazon', this.product.asin)
        .then((data) => {
          if (data.Code === 500) {
            this.dimensions_error = data.Message;
            return;
          }

          Vue.set(this.dimensions, 'width', data.width);
          Vue.set(this.dimensions, 'height', data.height);
          Vue.set(this.dimensions, 'length', data.length);
        });
    },
  },
};
</script>
<template src="./edit_products.pug" lang="pug"></template>
<style src="./edit_products.styl" lang="stylus" scoped></style>
